import React, {CSSProperties, useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import * as style from './ConnectWalletModal.style';
import * as styleH5 from './ConnectWalletModal.style.h5';
import {useStore} from "react-redux";
import {IState} from "../../store/reducer";
import {mapDispatchToProps} from "../../store/connect";
import {useEffectState} from "../../hooks/useEffectState";
import Toggle from "../toggle/Toggle";
import {awaitWrap} from "../../common/utilTools";
import Modal from '../modal/Modal';
import {CHAINS, IWallet, WALLETS} from "../../contract/config";
import {ethers} from "ethers";
import openModal, {IOpenModal} from "../openModal";
import WalletDownload, {IWalletDownload} from "../walletDownload/WalletDownload";
import {useWalletTools} from "../../hooks/useWalletTools";
import useRedux from "../../hooks/useRedux";
import {useAxios} from "../../ajax/axios";
import {LiTitle, NetworkBox, NetworkItem} from "./ConnectWalletModal.style";
import { useMessage } from "../../hooks/useMessage";
import useWidthChange from "../../hooks/useWidthChange";

export type IConnectWalletModal = {
    onClose?(): void
    onSuccess?(): void
}
export default function ConnectWalletModal(props: IConnectWalletModal & IOpenModal) {
    const {t} = useTranslation();
    const store = useStore<IState>();
    const dispatch = mapDispatchToProps(store.dispatch);
    const {storeData, reduxGetter} = useRedux();
    const { showMessage } = useMessage();
    const {fetchPost} = useAxios();
    const { isH5 } = useWidthChange();
    const {
        ConnectButton,
        Process,
        StepBox,
        Explain,
        Title,
        Subtitle,
        WalletBox,
        WalletList,
        IPWarn
    } = style;
    const step1Ref = useRef<HTMLDivElement | null>(null);
    const step2Ref = useRef<HTMLDivElement | null>(null);
    const [processStyle, setProcessStyle] = useState<CSSProperties>({});
    const state = useEffectState({
        stepNum: 1,
        loading: false,
        chain: "",
        wallet_info: storeData.wallet_info,
        chain_info: CHAINS.BSC,
        checking: false
    });
    const { accounts, activate, provider, deactivate, validWalletPlugin, connector, getWalletPlugin, connectWallet } = useWalletTools(state.wallet_info);

    useEffect(() => {
        if (reduxGetter.walletInfo) {
            connectWallet();
        }
    }, [reduxGetter.walletInfo]);
    useEffect(() => {
        if (storeData.address) {
            props.destoryComponent();
        }
    }, [storeData.address])

    function resetWalletAddress() {
        dispatch.setWalletAddress("");
        dispatch.setWallet(null);
    }

    async function login(address: string, signStr: string) {
        const [userInfo, error] = await awaitWrap(fetchPost<string>("/auth/auth/token", {address, signature: signStr}));
        if (userInfo) {
            dispatch.setToken(userInfo.data);
            dispatch.setWalletAddress(address);
            dispatch.setWallet(state.wallet_info);
            props.onSuccess && props.onSuccess();
            state.stepNum = 1;
            props.destoryComponent();
        } else {
            deactivate();
            resetWalletAddress();
        }
        state.loading = false;
    }

    function onSelect(wallet_info: IWallet) {
        if (!validWalletPlugin(wallet_info.plugin)) {
            if (isH5) {
                window.open(`https://metamask.app.link/dapp/pugsdoge.com/`, "_blank");
            } else {
                showMessage(t(`No Plugin was found`));
                openModal<IWalletDownload>(WalletDownload, {
                    wallet_info: wallet_info
                });
                props.onClose && props.onClose();
                props.destoryComponent();
            }
            return;
        }
        dispatch.setWallet(wallet_info);
        // state.wallet_info = wallet_info;
    }



    return (
        <Modal title={t(`Connect Wallet`)}
               titleStyle={{marginBottom: "15px"}}
               close={props.destoryComponent}
               disabledModalClick={state.stepNum === 2}
               isH5={isH5}
               style={isH5 ? {} : {width: "420px"}}>
            <div style={{margin: "0 0 1px"}}>
                <WalletList style={ isH5 ? {marginTop: "16px"} : {} }>
                    {
                        Object.values(WALLETS).filter((i) => {
                            return i.canClick;
                        }).map((item, index) => {
                            return <WalletBox key={item.name} onClick={() => {
                                if (item.canClick) {
                                    onSelect(item);
                                }
                            }}>
                                <img src={item.icon} className={"icon"} alt=""/>
                                <span>{item.name}</span>
                            </WalletBox>
                        })
                    }
                </WalletList>
            </div>
        </Modal>
    )
}
